// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__180Yh","buttons":"styles_buttons__1OXHI"};